var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.21 186.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4ec5cb;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.73,0c3.68.7,7.42,1.14,11.01,2.14,12.83,3.57,22.89,11.1,30.26,22.13,6.23,9.33,9.23,19.72,8.85,30.92-.59,17.13-7.87,30.95-21.34,41.52-.52.41-1.06.8-1.9,1.43,18.76,6.78,33.89,18.08,45.36,34.12,11.47,16.05,17,34.02,17.23,53.81h-14.44c-.82-27.28-12.21-49.08-34.58-64.79-14.46-10.15-30.8-14.44-48.42-13.55-40.05,2.04-74.11,35.61-74.31,78.42H0C0,184.36,0,182.54,0,180.72c.11-.52.27-1.04.31-1.56.64-9.62,2.72-18.94,6.45-27.82,10.49-25.02,28.44-42.47,53.71-52.36.63-.25,1.25-.5,2.09-.83-.81-.61-1.35-1-1.87-1.41-13.47-10.58-20.76-24.39-21.34-41.52-.38-11.2,2.61-21.59,8.85-30.93,7.37-11.03,17.43-18.56,30.26-22.14C82.04,1.14,85.78.7,89.46,0c2.42,0,4.85,0,7.27,0Zm35.63,53.88c.05-21.53-17.51-39.19-39.12-39.33-21.57-.14-39.36,17.56-39.42,39.21-.06,21.53,17.51,39.19,39.12,39.33,21.57.14,39.36-17.56,39.42-39.21Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.09c64303396b905fe7b8f97c69a8af4c.svg";
export { ForwardRef as ReactComponent };